import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import EnhancedTab from '../../../lib/designSystem/TabSimulation';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import {
  getBusiness,
  getBusinessRelation,
  getLastTGRScrapDates,
  getTemporaryBusinessViewsForExecutive,
} from '../../../lib/api';
import {
  executeScraping,
  getScrapingStatus,
} from '../../../lib/api/pruffRush';
import CenteredCircularProgress from '../../../lib/designSystem/CircularProgress';
import { Typography } from '@mui/material';
import TGRAgreements from './components/Agreements';
import TGRProceedings from './components/Proceedings';
import TGRDebts from './components/Debts';
import { formatDate } from '../../../lib/functions/utils';
import { formatDateToLocal } from '../../../lib/designSystem/Table/cellFormat';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../lib/designSystem/HeaderWithActions';
import { validatePermissions } from '../../../lib/functions/utils';
import { AuthState } from '../../../services/redux/authSlice';
import CustomButton from '../../../lib/designSystem/Button';

const TGRProfile = (props: any) => {
  const { id, page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const currentPath = window.location.pathname;
  const initialPath = currentPath.split('/')[2];
  const temporary = initialPath === 'temporary';
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState({ name: '', companies: [], identifier: '' });
  const [active, setAcitve] = useState(false);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const navigate = useNavigate();
  const [recentlyCreated, setRecentlyCreated] = useState(false);
  const [tgrUpdates, setTgrUpdates] = useState<any[]>([]);
  const [startValue, setStartValue] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [lastStateScraping, setLastStateScraping] = useState<any>([]);

  const createTabs = () => {
    return [
      { id: 0, label: 'Deuda Fiscal', component: <TGRDebts refreshTrigger={refreshTrigger} />, path: 'debts' },
      {
        id: 1,
        label: 'Convenios',
        component: <TGRAgreements />,
        path: 'agreements',
      },
      {
        id: 2,
        label: 'Cobranzas',
        component: <TGRProceedings />,
        path: 'collections',
      },
    ];
  };

  const handleNavigation = (index: number) => {
    navigate(`/companies/${id}/tgr/${companyTabs[index].path}`);
  };

  const handleNavigationTemporary = (index: number) => {
    navigate(`/companies/temporary/${id}/tgr/${companyTabs[index].path}`);
  };
  console.log(page);

  const checkCanAccessView = () => {
    const exists = companyTabs.find((x: any) => x.path === page);
    if (exists) return true;

    return false;
  };

  const mainBusiness = async () => {
    if (!id) {
      setLoading(false);
      return alert('Ha ocurrido un error');
    }

    // Fetch business data to get the identifier (RUT)
    try {
      const businessData = await getBusiness(dispatch, id);
      setBusiness(businessData || { name: '', companies: [], identifier: '' });
    } catch (error) {
      console.log('Error fetching business data:', error);
      setBusiness({ name: '', companies: [], identifier: '' });
    }

    const tgrUpdatesData = await fetchLastScrapDates();
    setTgrUpdates(tgrUpdatesData || []);

    const tabs = createTabs();

    console.log("tgrUpdates -> ", tgrUpdatesData);

    const tabsWithUpdates = tabs.map((tab: any) => {
      const update = tgrUpdatesData?.find(
        (x: any) => `${x.scraperId.split('-')[1]}s` === tab.path,
      );
      return {
        ...tab,
        hoverText:
          update &&
          `Revisado última vez: ${formatDateToLocal(update.lastScrapedAt, false)}`,
      };
    });
    console.log(tabsWithUpdates);
    let startValueDefault = 0;
    startValueDefault = tabsWithUpdates.findIndex((x: any) => x.path === page);
    setCompanyTabs(tabsWithUpdates);
    console.log(tabsWithUpdates);
    console.log(startValueDefault);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
  };

  const fetchLastScrapDates = async () => {
    if (!id) {
      setLoading(false);
      return alert('Ha ocurrido un error');
    }
    try {
      return await getLastTGRScrapDates(dispatch, id);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchRelations = async () => {
    console.log(id, temporary);
    setLoading(true);
    if (!id) {
      return setLoading(false);
    }
    await mainBusiness();

    // if (!temporary) {
    //   await mainBusiness()
    // } else {
    //   await temporaryBusiness()
    // }

    setLoading(false);
    setRefreshing(false);
  };

  const checkIfDataNeedsRefresh = () => {
    if (!tgrUpdates || !Array.isArray(tgrUpdates)) return false;
    
    // Check if any of the TGR scrapers has data older than 24 hours
    return tgrUpdates.some(update => {
      const lastScrapedAt = new Date(update.lastScrapedAt);
      const now = new Date();
      const hoursDifference = (now.getTime() - lastScrapedAt.getTime()) / (1000 * 60 * 60);
      
      return hoursDifference > 24;
    });
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      if (business.identifier) {
        await executeScraping(dispatch, 'tgr', business.identifier);
      } else {
        console.log('No business identifier available for TGR scraping');
      }
    } catch (error) {
      console.log('Error triggering TGR scraping:', error);
      // Show user-friendly error message
      //alert('Error al actualizar datos TGR. El servicio de scraping no está disponible.');
    }
    // Trigger refresh in TGRDebts component
    setRefreshTrigger(prev => prev + 1);
    await fetchRelations();
  };

  useEffect(() => {
    fetchRelations();
  }, []);



  if (loading) return <CenteredCircularProgress />;

  const handleNavigationBack = () => {
    navigate(`/companies`);
  };

  const buttons: CustomButtonProps[] = [
    {
      name: 'Actualizar',
      action: handleRefresh,
      color: 'primary',
      loading: refreshing,
      disabled: !checkIfDataNeedsRefresh(),
    },
  ];

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        title={temporary ? business.name : undefined}
        tabs={companyTabs}
        onTabChange={!temporary ? handleNavigation : handleNavigationTemporary}
        // canShowTab={checkCanAccessView()}
        chip={
          <CustomButton
            onClick={handleRefresh}
            color="primary"
            loading={refreshing}
            disabled={!checkIfDataNeedsRefresh()}
          >
            Actualizar
          </CustomButton>
        }
      />
      {recentlyCreated && (
        <Typography variant="body1" color="error">
          *Esta empresa fue conectada hace menos de 5 minutos, algunas facturas
          todavía se están cargando...
        </Typography>
      )}
    </div>
  );
};

export default TGRProfile;
